import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../lib/api';
import MkdfLogo from '../components/MkdfLogo';
import DFFilesLogo from '../components/DFFilesLogo';

const PasswordResetRequest: React.FC = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = (): boolean => {
    if (!email) {
      setEmailError('メールアドレスを入力してください');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('正しいメールアドレスを入力してください');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      await apiClient.post('/api/v1/auth/password-reset', { email });
    } catch {
      // Always show success message to prevent email enumeration
    } finally {
      setIsLoading(false);
      setIsSubmitted(true);
    }
  };

  return (
    <div className="hero-gradient">
      <div className="hero-card">
        <div className="hero-card__header">
          <div className="hero-card__logo">
            <MkdfLogo height={28} />
            <span className="header__brand-divider" style={{ margin: '0 8px', opacity: 0.3 }}>|</span>
            <DFFilesLogo size={24} variant="light" />
          </div>
          <div className="hero-card__tagline">パスワードリセット</div>
        </div>

        <div className="hero-card__body">
          {isSubmitted ? (
            <div>
              <div className="alert alert--success">
                パスワードリセット用のメールを送信しました。メールをご確認ください。
              </div>
              <Link to="/login" className="btn btn--secondary btn--block mt-4">
                ログイン画面に戻る
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="mb-4" style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                登録済みのメールアドレスを入力してください。パスワードリセット用のリンクをお送りします。
              </p>

              <div className="form-group">
                <label htmlFor="email" className="form-label">メールアドレス</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  placeholder="example@company.com"
                  className={`form-input ${emailError ? 'form-input--error' : ''}`}
                />
                {emailError && <p className="form-error">{emailError}</p>}
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="btn btn--primary btn--lg btn--block mb-4"
              >
                {isLoading ? '送信中...' : 'リセットリンクを送信'}
              </button>

              <div style={{ textAlign: 'center' }}>
                <Link to="/login">ログイン画面に戻る</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordResetRequest;
